/* 
    *  You have to include the store in each modal because  
    *  ionic decided they didn't need to access it. This 
    *  also won't show up in your Vue Debugger.
*/

import './styles.scss';
import store from '../../store/';
import every from 'lodash/every';

const PhoneInput = () => import('../phone-input/index.vue');

export default {
    name: 'AddContactModal',

    store,

    components: {
        'phone-input': PhoneInput
    },

    data() {
        return {
            contact: {
                name: '',
                phone: [
                    {
                        phone_number: '',
                        valid: false,
                        type: 1,
                        id: Math.random().toString(36).substring(7)
                    }
                ],
                type: '',
                notes: ''
            }
        }
    },

    computed: {
        types() {
            return this.$store.getters.getContactTypes;
        },

        canSubmit() {
            return this.contact.name.length && this.contact.type.length && every(this.contact.phone, 'valid');
        }
    },

    methods: {
        dismissModal() {
            this.$ionic.modalController.dismiss();
        },

        addPhone() {
            const phone = {
                phone_number: '',
                type: this.contact.phone.length + 1,
                id: Math.random().toString(36).substring(7)
            };

            this.contact.phone.push(phone);
        },

        deletePhone(index) {
            this.contact.phone.splice(index, 1);

            this.contact.phone.forEach((phone, index) => {
                this.updatePhone(phone, index);
            });
        },

        updatePhone(event, index) {
            this.contact.phone[index].phone_number = event.value;
            this.contact.phone[index].valid = event.valid;
            this.contact.phone[index].type = index + 1;
        },

        createContact() {
            if (this.$store.state.online_status) {
                this.contact.subscription = this.$store.state.subscriptions.active_subscription.id;

                this.$store.dispatch('createContactDB', this.contact).then((response) => {
                    this.$ionic.modalController.dismiss();
                }).catch((error) => {
                    this.$ionic.alertController.create({
                        message: 'Unable to create contact.',
                        buttons:['OK']
                    }).then(a => a.present());
                });
            } else {
                this.$ionic.alertController.create({
                    message: 'Please establish and internet connection and try again.',
                    buttons:['OK']
                }).then(a => a.present());
            }
        }
    }
};